import { Snackbar, Slide, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { connect } from "react-redux";

import { popupMessagesHandler } from "../redux/Orders/OrderActionCreators";
import Store from "../redux/Store";
function MessageHandler({ popupMessages }) {
  const handleClose = (event, reason) => {
    Store.dispatch(
      popupMessagesHandler({ mode: false, message: "", color: "info" })
    );
  };
  return (
    <Snackbar
      open={popupMessages.mode}
      onClose={handleClose}
      autoHideDuration={2000}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      TransitionComponent={(props) => {
        return <Slide {...props} direction="right" />;
      }}
    >
      <Alert
        variant="filled"
        onClose={handleClose}
        severity={popupMessages.color}
      >
        {popupMessages.message}
      </Alert>
    </Snackbar>
  );
}

const mapStateToProps = (props) => {
  const { OrderReducer } = props;
  const { popupMessages } = OrderReducer;
  return { popupMessages };
};
export default connect(mapStateToProps)(MessageHandler);
export const TableRowErrorMessage = () => {
  return (
    <Typography
      variant="subtitle1"
      style={{ marginTop: "20px" }}
      color="secondary"
    >
      موردی یافت نشد
    </Typography>
  );
};
